// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"23":"ad3e1a73e4b38200","24":"c0566e174a416f6b","797":"a954159a856f0e0e","935":"49fcfa4298f5e0d4"}[chunkId] + ".js";
};